module.exports = __webpack_public_path__ + "5122d46999be6e515b72f728ce8f3b80.svg";